module.exports = __webpack_public_path__ + "images/emoji/goat.a4c939a9992c95e3c1c8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/goat.png
// module id = 2wyo
// module chunks = 13